// FloorCreateStep represents the current step of the floor editing flow
export enum FloorCreateStep {
	Intro,
	Details,
	ImportPrompt,
	ImportUpload,
	ImportReview,
	Place,
	DrawPrompt,
	Draw,
}
